import React from "react";

const InLightNewsSkeleton: React.FC = () => {
  return (
    <>
      <div className="skeleton w-[650px] max-md:w-full h-20 max-md:h-16 my-4"></div>
      <div className="mt-40 mb-14 max-sm:mx-auto max-md:mt-40 flex max-md:flex-col-reverse max-md:items-center justify-end mr-20 max-md:h-[800px]">
        <div className="skeleton w-[400px] h-[560px] !rounded-[20%] max-sm:!rounded-xl max-sm:w-full relative">
          <div className="skeleton w-[400px] h-[355px] !rounded-[45%_50%_50%_45%] absolute -left-[90%] max-md:left-1/2 max-md:-translate-x-1/2 max-md:-bottom-[60%] top-[10%] max-md:top-auto -rotate-6"></div>
          <div className="skeleton w-48 h-28 absolute -top-32 left-1/2 -translate-x-1/2"></div>
        </div>
      </div>
    </>
  );
};

export default InLightNewsSkeleton;
